import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route.ts';

export const invitationsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.invitations.root,
    lazyImport: () => import('../../domains/protected/invitations/InvitationsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'invitation',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/invitations/pages/invitations-list/InvitationsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.invitations.details,
        lazyImport: () =>
          import('../../domains/protected/invitations/pages/invitation-details/InvitationDetailsParentRoute.tsx'),
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/invitations/pages/invitation-details/InvitationDetailsRoute.tsx'),
            nav: {
              backTo: routesPaths.invitations.root,
              breadcrumbKey: 'details'
            }
          },
          {
            path: 'responses/:responseId',
            lazyImport: () =>
              import('../../domains/protected/invitations/pages/response/ResponseRoute.tsx'),
            nav: {
              backTo: routesPaths.invitations.details(':id'),
              breadcrumbKey: 'details'
            }
          },
          {
            path: 'responses',
            lazyImport: () =>
              import('../../domains/protected/invitations/pages/ResponseDetailsRedirectRoute.tsx')
          }
        ]
      },
      {
        path: '*',
        redirectTo: baseRoutes.invitations.root
      }
    ]
  }
];
